enum VehiclePropertyFlags {
	None = 0,
	Plate = 1,
	Province = 2,
	Color = 4,
	Model = 8,
	Nickname = 16,
	Type = 32
}

export default VehiclePropertyFlags;
